import ContractConfigurator from './ContractConfigurator';

export default ContractConfigurator;
